{
  "nav": {
    "home": "Inicio",
    "session": "Sesión",
    "about": "Acerca de"
  },
  "topbar": {
    "toggleNavigation": "Alternar navegación",
    "search": "Buscar",
    "openAiChat": "Abrir chat de IA",
    "switchToEnglish": "Cambiar a inglés",
    "switchToSpanish": "Cambiar a español",
    "logIn": "Iniciar sesión",
    "logOut": "Cerrar sesión",
    "copyRoom": "Copiar sala",
    "copied": "Copiado"
  },
  "sidenav": {
    "userSubtitle": "usuario de future-room"
  },
  "aiChat": {
    "label": "Chat de IA",
    "comingSoon": "El chat de IA estará disponible pronto"
  },
  "home": {
    "heading": "Room of the Future",
    "paragraph1": "future-room es el nuevo hogar de la sala de terapia de Presence Learning. La sesión se abre en un Space de Lessonspace.",
    "paragraph2": "Cada elemento que ves aquí, desde la navegación hasta el tema visual, está construido sobre nuestra biblioteca de componentes compartida, para que la aplicación se vea y se comporte de manera consistente con el resto de la plataforma Presence desde el primer día.",
    "paragraph3": "Esto todavía está en una etapa temprana: la mayor parte de lo que eventualmente vivirá aquí aún no se ha construido. Vuelve a revisar a medida que se traslade más de la experiencia."
  },
  "door": {
    "providerHeading": "Sesión",
    "providerIntro": "Abre la sala y copia el enlace. Los estudiantes usan ese enlace y esperan en la sala de espera de Lessonspace.",
    "openClassroom": "Abrir la sala",
    "loadingSchedule": "Cargando el horario.",
    "noAppointment": "No hay una cita en el horario.",
    "startAdhoc": "Iniciar una reunión ad hoc",
    "adhocHeading": "Reunión ad hoc",
    "untitledAppointment": "Cita",
    "notStarted": "Esta cita aún no comienza. Igual puedes abrir su sala.",
    "clientsHeading": "Clientes",
    "doorDown": "La puerta local de Lessonspace no está en marcha. Iníciala con npm run lessonspace:door.",
    "studentHeading": "Unirse a la sesión",
    "yourName": "Tu nombre",
    "join": "Unirse",
    "joining": "Uniéndose a la sala.",
    "missingRoom": "Este enlace de sala no es válido.",
    "scheduleFailed": "No se pudo cargar el horario.",
    "launchFailed": "No se pudo abrir la sala.",
    "joinFailed": "No se pudo abrir la sala. ¿Está en marcha la puerta local?",
    "openGif": "Abrir GIF",
    "closeOverlay": "Cerrar",
    "overlayTitle": "Recurso de ejemplo",
    "overlayImage": "Abuela bailando"
  },
  "about": {
    "heading": "Acerca de",
    "paragraph1": "Este proyecto existe para darle al equipo de ingeniería de Presence Learning una base moderna y bien probada sobre la cual construir, en lugar de seguir extendiendo una base de código antigua que se ha vuelto más difícil de modificar con seguridad con el tiempo.",
    "paragraph2": "Priorizamos la accesibilidad, el rendimiento y la observabilidad desde el primer commit, de modo que el estándar de calidad para cada nueva pantalla se establece antes de que la pantalla misma exista.",
    "paragraph3": "La migración ocurrirá de forma incremental, un portal y un flujo de trabajo a la vez, para que los usuarios experimenten un flujo constante de mejoras en lugar de una transición grande y riesgosa."
  }
}
